import { useState } from "react";
import { Loader2, Mail } from "lucide-react";
import { colors } from "../../styles/theme";
import { Button } from "../../components/ui";
import { resendZoomInvitations } from "../../services/api";

export default function ResendButton({ eventId, unregisteredCount, onResent }) {
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);

  const handleResend = async () => {
    if (!window.confirm(`Resend invitations to ${unregisteredCount} contact${unregisteredCount !== 1 ? "s" : ""} who haven't registered?`)) return;
    setSending(true);
    setResult(null);
    try {
      const data = await resendZoomInvitations(eventId);
      setResult(`Resent to ${data.resent} contact${data.resent !== 1 ? "s" : ""}`);
      onResent();
    } catch (err) {
      setResult(`Error: ${err.message}`);
    } finally {
      setSending(false);
    }
  };

  return (
    <div style={{ marginBottom: 12, padding: "10px 12px", background: "rgba(245,158,11,0.06)", borderRadius: 8, border: `1px solid rgba(245,158,11,0.15)` }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <span style={{ fontSize: 12, color: colors.textSecondary }}>
          {unregisteredCount} invited but not registered
        </span>
        <Button variant="default" size="sm" onClick={handleResend} disabled={sending}>
          {sending ? <><Loader2 size={12} className="spin" /> Sending...</> : <><Mail size={12} /> Resend to Unopened</>}
        </Button>
      </div>
      {result && <div style={{ fontSize: 11, color: result.startsWith("Error") ? colors.danger : colors.success, marginTop: 6 }}>{result}</div>}
    </div>
  );
}
